// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-area-table {
  background: var(--secondary-color);
  border-radius: 5px;
  box-shadow: var(--light-shadow1);
  padding: 12px 16px;
  /* HTML: <div class="loader"></div> */
}
@media (max-width: 768px) {
  .content-area-table {
    padding: 12px;
  }
}
.content-area-table .data-table-title {
  font-size: 18px;
  color: var(--xl-text-color);
  margin-bottom: 12px;
}
.content-area-table .data-table-diagram {
  border-radius: 6px;
  border: 1px solid var(--tbl-border-color) !important;
  overflow-x: scroll;
}
.content-area-table .data-table-diagram::-webkit-scrollbar {
  height: 6px;
  width: 6px;
}
.content-area-table .data-table-diagram::-webkit-scrollbar-track {
  background-color: var(--scroll-track-bg-color);
}
.content-area-table .data-table-diagram::-webkit-scrollbar-thumb {
  border-radius: 100vh !important;
  background-color: #e9e9e9;
  outline: 1px solid rgba(0, 0, 0, 0.02);
  outline-offset: -1px;
}
.content-area-table .data-table-diagram table {
  min-width: 900px;
  width: 100%;
  border-collapse: collapse;
  color: var(--text-color-inverted);
}
.content-area-table .data-table-diagram table td,
.content-area-table .data-table-diagram table th {
  padding: 14px 12px;
}
@media (max-width: 768px) {
  .content-area-table .data-table-diagram table td,
  .content-area-table .data-table-diagram table th {
    font-size: 15px;
    padding: 12px 10px;
  }
}
.content-area-table .data-table-diagram table thead {
  text-align: left;
  font-size: 17px;
  background-color: var(--thead-bg-color);
}
.content-area-table .data-table-diagram table thead th:last-child {
  text-align: center;
}
.content-area-table .data-table-diagram table .dt-cell-action {
  text-align: center;
}
.content-area-table .data-table-diagram table .dt-status {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  column-gap: 6px;
}
.content-area-table .data-table-diagram table .dt-status .dt-status-dot {
  width: 8px;
  height: 8px;
  border-radius: 100%;
}
.content-area-table .data-table-diagram table .dt-status .dt-status-dot.dot-pending {
  background-color: var(--orange-color);
}
.content-area-table .data-table-diagram table .dt-status .dt-status-dot.dot-canceled {
  background-color: var(--red-color);
}
.content-area-table .data-table-diagram table .dt-status .dt-status-dot.dot-delivered {
  background-color: var(--green-color);
}
.content-area-table .data-table-diagram table .dt-status .dt-status-text {
  text-transform: capitalize;
}
.content-area-table .action-dropdown-btn {
  color: var(--text-color-inverted);
  position: relative;
}
.content-area-table .action-dropdown-menu {
  position: absolute;
  top: 100%;
  right: 50%;
  transform: translateX(50%);
  height: auto;
  min-width: 80px;
  box-shadow: rgba(100, 100, 111, 0.1) 0px 1px 4px 0px;
  background-color: var(--secondary-color);
  padding: 6px 10px;
  z-index: 1;
  border-radius: 8px;
  border: 1px solid var(--border-color-inverted);
  text-align: left;
}
.content-area-table .dropdown-menu-item {
  margin: 8px 0;
}
.content-area-table .dropdown-menu-link {
  color: var(--text-color-inverted);
  font-weight: 600;
  transition: var(--default-transition);
}
.content-area-table .dropdown-menu-link:hover {
  opacity: 0.9;
}
.content-area-table .buttons {
  display: flex;
  gap: 10px;
}
.content-area-table .button {
  padding: 5px 10px;
  border-radius: 5px;
  color: var(--text);
  border: none;
  cursor: pointer;
}
.content-area-table .addButton {
  padding: 10px;
  background-color: #5d57c9;
  color: var(--text);
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.content-area-table .view {
  background-color: var(--blue-color);
  color: white;
}
.content-area-table .delete {
  background-color: crimson;
}
.content-area-table .AddSpan {
  color: white !important;
  padding: 4px 22px;
  margin-bottom: 11px;
  border-radius: 5px;
  cursor: pointer;
  background: rgb(247, 119, 59);
  background: linear-gradient(90deg, #16267d 35%, #182061 100%);
}
.content-area-table .delBtnModal {
  background: rgb(247, 119, 59);
  background: linear-gradient(90deg, #16267d 35%, #182061 100%);
  border: none;
  padding: 4px 95px;
  color: white;
  border-radius: 6px;
  font-size: 20px;
}
.content-area-table .editspan {
  padding: 8px 15px;
  background-color: #f3f3f3;
  border-radius: 5px;
  color: white;
  cursor: pointer;
  /* margin: 0 20px; */
}
.content-area-table .deletespan {
  padding: 2px 15px;
  background-color: #f3f3f3;
  border-radius: 5px;
  color: rgb(239, 7, 7);
  cursor: pointer;
}
.content-area-table .flexEnd {
  display: flex;
  align-items: center;
  justify-content: end;
}
.content-area-table .search {
  display: flex;
  align-items: center;
  gap: 10px;
  background-color: rgb(198, 196, 196);
  padding: 10px;
  border-radius: 10px;
  width: 20%;
}
.content-area-table .input {
  background-color: transparent;
  border: none;
  color: var(--text);
  outline: none;
}
.content-area-table .loader {
  width: 65px;
  height: 117px;
  position: relative;
}
.content-area-table .loader:before,
.content-area-table .loader:after {
  content: "";
  position: absolute;
  inset: 0;
  background: #ff8001;
  box-shadow: 0 0 0 50px;
  clip-path: polygon(100% 0, 23% 46%, 46% 44%, 15% 69%, 38% 67%, 0 100%, 76% 57%, 53% 58%, 88% 33%, 60% 37%);
}
.content-area-table .loader:after {
  animation: l8 1s infinite;
  transform: perspective(300px) translateZ(0px);
}
@keyframes l8 {
  to {
    transform: perspective(300px) translateZ(180px);
    opacity: 0;
  }
}
.content-area-table .logoutBtn {
  background-color: var(--blue-color);
  color: #fff;
  border: none;
  padding: 8px 16px;
  border-radius: 50px;
  cursor: pointer;
  font-size: 1.2rem;
}
.content-area-table .logoutBtn:hover {
  background-color: var(--light-color);
}`, "",{"version":3,"sources":["webpack://./src/screen/Admin/resellers/viewTable.scss"],"names":[],"mappings":"AAAA;EACE,kCAAA;EACA,kBAAA;EACA,gCAAA;EACA,kBAAA;EAyNA,qCAAA;AAvNF;AAAE;EANF;IAOI,aAAA;EAGF;AACF;AADE;EACE,eAAA;EACA,2BAAA;EACA,mBAAA;AAGJ;AAAE;EACE,kBAAA;EACA,oDAAA;EACA,kBAAA;AAEJ;AAAI;EACE,WAAA;EACA,UAAA;AAEN;AACI;EACE,8CAAA;AACN;AACI;EACE,+BAAA;EACA,yBAAA;EACA,sCAAA;EACA,oBAAA;AACN;AAEI;EACE,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,iCAAA;AAAN;AAEM;;EAEE,kBAAA;AAAR;AACQ;EAHF;;IAII,eAAA;IACA,kBAAA;EAGR;AACF;AAAM;EACE,gBAAA;EACA,eAAA;EACA,uCAAA;AAER;AACU;EACE,kBAAA;AACZ;AAIM;EACE,kBAAA;AAFR;AAKM;EACE,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,eAAA;AAHR;AAKQ;EACE,UAAA;EACA,WAAA;EACA,mBAAA;AAHV;AAKU;EACE,qCAAA;AAHZ;AAKU;EACE,kCAAA;AAHZ;AAKU;EACE,oCAAA;AAHZ;AAOQ;EACE,0BAAA;AALV;AAWE;EACE,iCAAA;EACA,kBAAA;AATJ;AAYE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,0BAAA;EACA,YAAA;EACA,eAAA;EACA,oDAAA;EACA,wCAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,8CAAA;EACA,gBAAA;AAVJ;AAaE;EACE,aAAA;AAXJ;AAcE;EACE,iCAAA;EACA,gBAAA;EACA,qCAAA;AAZJ;AAcI;EACE,YAAA;AAZN;AAgBE;EACE,aAAA;EACA,SAAA;AAdJ;AAiBE;EACE,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;AAfJ;AAiBE;EACE,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAfJ;AAkBE;EACE,mCAAA;EACA,YAAA;AAhBJ;AAmBE;EACE,yBAAA;AAjBJ;AAoBE;EACE,uBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,6BAAA;EACA,6DAAA;AAlBJ;AAqBE;EACE,6BAAA;EACA,6DAAA;EACA,YAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAnBJ;AAsBE;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,eAAA;EACA,oBAAA;AApBJ;AAuBE;EACE,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,qBAAA;EACA,eAAA;AArBJ;AAwBE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;AAtBJ;AAyBE;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,UAAA;AAvBJ;AA0BE;EACE,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;AAxBJ;AA4BE;EACE,WAAA;EACA,aAAA;EACA,kBAAA;AA1BJ;AA4BE;;EAEE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,mBAAA;EACA,sBAAA;EACA,0GAAA;AA1BJ;AAuCE;EACE,yBAAA;EACA,6CAAA;AArCJ;AAuCE;EACE;IACE,+CAAA;IACA,UAAA;EArCJ;AACF;AAwCE;EACE,mCAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;AAtCJ;AAwCE;EACE,oCAAA;AAtCJ","sourcesContent":[".content-area-table {\n  background: var(--secondary-color);\n  border-radius: 5px;\n  box-shadow: var(--light-shadow1);\n  padding: 12px 16px;\n\n  @media (max-width: 768px) {\n    padding: 12px;\n  }\n\n  .data-table-title {\n    font-size: 18px;\n    color: var(--xl-text-color);\n    margin-bottom: 12px;\n  }\n\n  .data-table-diagram {\n    border-radius: 6px;\n    border: 1px solid var(--tbl-border-color) !important;\n    overflow-x: scroll;\n\n    &::-webkit-scrollbar {\n      height: 6px;\n      width: 6px;\n    }\n\n    &::-webkit-scrollbar-track {\n      background-color: var(--scroll-track-bg-color);\n    }\n    &::-webkit-scrollbar-thumb {\n      border-radius: 100vh !important;\n      background-color: #e9e9e9;\n      outline: 1px solid rgba(0, 0, 0, 0.02);\n      outline-offset: -1px;\n    }\n\n    table {\n      min-width: 900px;\n      width: 100%;\n      border-collapse: collapse;\n      color: var(--text-color-inverted);\n\n      td,\n      th {\n        padding: 14px 12px;\n        @media (max-width: 768px) {\n          font-size: 15px;\n          padding: 12px 10px;\n        }\n      }\n\n      thead {\n        text-align: left;\n        font-size: 17px;\n        background-color: var(--thead-bg-color);\n\n        th {\n          &:last-child {\n            text-align: center;\n          }\n        }\n      }\n\n      .dt-cell-action {\n        text-align: center;\n      }\n\n      .dt-status {\n        display: flex;\n        align-items: center;\n        justify-content: flex-start;\n        column-gap: 6px;\n\n        .dt-status-dot {\n          width: 8px;\n          height: 8px;\n          border-radius: 100%;\n\n          &.dot-pending {\n            background-color: var(--orange-color);\n          }\n          &.dot-canceled {\n            background-color: var(--red-color);\n          }\n          &.dot-delivered {\n            background-color: var(--green-color);\n          }\n        }\n\n        .dt-status-text {\n          text-transform: capitalize;\n        }\n      }\n    }\n  }\n\n  .action-dropdown-btn {\n    color: var(--text-color-inverted);\n    position: relative;\n  }\n\n  .action-dropdown-menu {\n    position: absolute;\n    top: 100%;\n    right: 50%;\n    transform: translateX(50%);\n    height: auto;\n    min-width: 80px;\n    box-shadow: rgba(100, 100, 111, 0.1) 0px 1px 4px 0px;\n    background-color: var(--secondary-color);\n    padding: 6px 10px;\n    z-index: 1;\n    border-radius: 8px;\n    border: 1px solid var(--border-color-inverted);\n    text-align: left;\n  }\n\n  .dropdown-menu-item {\n    margin: 8px 0;\n  }\n\n  .dropdown-menu-link {\n    color: var(--text-color-inverted);\n    font-weight: 600;\n    transition: var(--default-transition);\n\n    &:hover {\n      opacity: 0.9;\n    }\n  }\n\n  .buttons {\n    display: flex;\n    gap: 10px;\n  }\n\n  .button {\n    padding: 5px 10px;\n    border-radius: 5px;\n    color: var(--text);\n    border: none;\n    cursor: pointer;\n  }\n  .addButton {\n    padding: 10px;\n    background-color: #5d57c9;\n    color: var(--text);\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n  }\n\n  .view {\n    background-color: var(--blue-color);\n    color: white;\n  }\n\n  .delete {\n    background-color: crimson;\n  }\n\n  .AddSpan {\n    color: white !important;\n    padding: 4px 22px;\n    margin-bottom: 11px;\n    border-radius: 5px;\n    cursor: pointer;\n    background: rgb(247, 119, 59);\n    background: linear-gradient(90deg, #16267d 35%, #182061 100%);\n  }\n\n  .delBtnModal {\n    background: rgb(247, 119, 59);\n    background: linear-gradient(90deg, #16267d 35%, #182061 100%);\n    border: none;\n    padding: 4px 95px;\n    color: white;\n    border-radius: 6px;\n    font-size: 20px;\n  }\n\n  .editspan {\n    padding: 8px 15px;\n    background-color: #f3f3f3;\n    border-radius: 5px;\n    color: white;\n    cursor: pointer;\n    /* margin: 0 20px; */\n  }\n\n  .deletespan {\n    padding: 2px 15px;\n    background-color: #f3f3f3;\n    border-radius: 5px;\n    color: rgb(239, 7, 7);\n    cursor: pointer;\n  }\n\n  .flexEnd {\n    display: flex;\n    align-items: center;\n    justify-content: end;\n  }\n\n  .search {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    background-color: rgb(198, 196, 196);\n    padding: 10px;\n    border-radius: 10px;\n    width: 20%;\n  }\n\n  .input {\n    background-color: transparent;\n    border: none;\n    color: var(--text);\n    outline: none;\n  }\n\n  /* HTML: <div class=\"loader\"></div> */\n  .loader {\n    width: 65px;\n    height: 117px;\n    position: relative;\n  }\n  .loader:before,\n  .loader:after {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    background: #ff8001;\n    box-shadow: 0 0 0 50px;\n    clip-path: polygon(\n      100% 0,\n      23% 46%,\n      46% 44%,\n      15% 69%,\n      38% 67%,\n      0 100%,\n      76% 57%,\n      53% 58%,\n      88% 33%,\n      60% 37%\n    );\n  }\n  .loader:after {\n    animation: l8 1s infinite;\n    transform: perspective(300px) translateZ(0px);\n  }\n  @keyframes l8 {\n    to {\n      transform: perspective(300px) translateZ(180px);\n      opacity: 0;\n    }\n  }\n\n  .logoutBtn {\n    background-color: var(--blue-color);\n    color: #fff;\n    border: none;\n    padding: 8px 16px;\n    border-radius: 50px;\n    cursor: pointer;\n    font-size: 1.2rem;\n  }\n  .logoutBtn:hover {\n    background-color: var(--light-color);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
